import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51f3297c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=51f3297c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f3297c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f3297c')) {
      api.createRecord('51f3297c', component.options)
    } else {
      api.reload('51f3297c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=51f3297c&scoped=true", function () {
      api.rerender('51f3297c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/previewInvoices/index.vue"
export default component.exports